// extracted by mini-css-extract-plugin
export default {"notFound":"notFound_notFound__AdL0e"};